import { FeaturePermissionsEnum } from "./featurePermissionsEnum";
import { HazardPermissionsEnum } from "./hazardPermissionsEnum";
import { MenuPermissionsEnum } from "./menuPermissionsEnum";

// keep the same name so we can use it as both type and value
export const PermissionIdEnum = {
  ...HazardPermissionsEnum,
  ...FeaturePermissionsEnum,
  ...MenuPermissionsEnum,
  Super: "super",
} as const;

export type PermissionIdEnum = (typeof PermissionIdEnum)[keyof typeof PermissionIdEnum];
